import React from "react";
import "./Branding_How_it_Works_card.css";

function Branding_How_it_Works_card(props) {
  console.log("props",props)
  return (
    <>
      <section className="Branding_How_it_Works_card">
        <div className="row">
          <div className="col-xl-3 col-lg-4 col-md-4">
            <div className="heading_holder">
              <div className="number_holder">
                <h3>{props?.index}</h3>
              </div>

              <div className="heading_text_holder">
                <h3>{props?.title}</h3>
                <h3>{props?.title2}</h3>
              </div>
            </div>
          </div>

          <div className="col-xl-9 col-lg-8 col-md-8">
            <div className="text_holder">
              <p>
                {props?.descn}
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Branding_How_it_Works_card;
